"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Text = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _lodash = require("lodash");

var _withSpacing = _interopRequireWildcard(require("../withSpacing"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var styles = {
  "screen-small": "(max-width: 539px)",
  "screen-gt-small": "(min-width: 540px)",
  "screen-medium": "(max-width: 959px)",
  "screen-gt-medium": "(min-width: 960px)",
  "screen-large": "(max-width: 1247px)",
  "screen-gt-large": "(min-width: 1248px)",
  "screen-x-large": "(max-width: 1919px)",
  "screen-gt-x-large": "(min-width: 1920px)",
  "text": "tcl__Text-03d692ab",
  "xSmall": "tcl__Text-1001c5fd",
  "small": "tcl__Text-267ecb65",
  "medium": "tcl__Text-51d594d4",
  "block": "tcl__Text-b0b3d22f",
  "inline": "tcl__Text-0f893f24",
  "bold": "tcl__Text-5740cf80",
  "italic": "tcl__Text-dcfec505",
  "truncated": "tcl__Text-dec94145",
  "color-black": "tcl__Text-be9c77e8",
  "color-white": "tcl__Text-4f626d15",
  "color-grey": "tcl__Text-458d0069",
  "color-light-grey": "tcl__Text-2cd619e6",
  "color-teal": "tcl__Text-e9e2980a",
  "color-green": "tcl__Text-d8dde582",
  "color-orange": "tcl__Text-c49192dd",
  "color-red": "tcl__Text-57d44bd2"
};
/**
 * Default text. Use it for displaying inline text or full paragraphs.
 */

const Text = ({
  children,
  elName,
  inline,
  bold,
  italic,
  size,
  truncated,
  color,
  ...props
}) => {
  const className = (0, _classnames.default)(styles.text, styles[(0, _lodash.camelCase)(size)], {
    [styles.block]: !inline,
    [styles.inline]: inline,
    [styles.bold]: bold,
    [styles.italic]: italic,
    [styles.truncated]: truncated,
    [styles[`color-${color}`]]: !!color && color
  }, props.className);
  const El = elName || (inline ? 'span' : 'p');
  if (!children) return null;
  return /*#__PURE__*/_react.default.createElement(El, _extends({}, props, {
    className: className
  }), children);
};

exports.Text = Text;
Text.displayName = "Text";
Text.propTypes = { ..._withSpacing.propTypes,

  /**
   * Any additional css classes.
   */
  className: _propTypes.default.string,

  /**
   * Content.
   */
  children: _propTypes.default.node,

  /**
   * Use custom element.
   */
  elName: _propTypes.default.string,

  /**
   * Display as inline text.
   */
  inline: _propTypes.default.bool,

  /**
   * Truncates text if it overflows.
   */
  truncated: _propTypes.default.bool,

  /**
   * Display text in bold font-weight.
   */
  bold: _propTypes.default.bool,

  /**
   * Display text in italic font-style.
   */
  italic: _propTypes.default.bool,

  /**
   * The size of the text.
   */
  size: _propTypes.default.oneOf(['x-small', 'small', 'medium']),

  /**
   * Predefined icon color. By default it inherits from parent.
   */
  color: _propTypes.default.oneOf(['black', 'grey', 'light-grey', 'white', 'teal', 'green', 'orange', 'red'])
};
Text.defaultProps = {
  className: '',
  inline: false,
  bold: false,
  italic: false,
  size: 'small',
  color: null,
  truncated: false,
  children: null,
  elName: null
};

var _default = (0, _withSpacing.default)(Text);

exports.default = _default;